// Arquivo utilizado para armazenar todos os estilos de cores utilizados no projeto;
const colors = {
  font_header:"#111",
  font_h2: "#262626",
  font_h2_pink: "#ff40a7",
  font_h4: "#FFFFFF",
  font_text: "#262626",
  font_text_light: "#5d5d66",
  font_text_white: "#FFFFFF",
  font_link: "#2d9cdb",
  background_header: "#FFFFFF",
  background_header_hover: "#F4F4F4",
  background_container_gray: "#EBEBEB",
  background_container_blue: "#38acff",
  background_button: "#ff40a7"
};

export default colors;